import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function FailedAlert(props) {
  const { show, message, onConfirm } = props;
  return (
    <SweetAlert error title="Gagal" show={show} onConfirm={onConfirm}>
      <p className="sweet-alert-text">
        {message ? message : "Kesalahan Tidak Diketahui!"}
      </p>
    </SweetAlert>
  );
}
